import React from "react";

function TestimonialItem({ review, isModal = false, openModal = () => {} }) {
  return (
    <div className="testimonials ttm-testimonial-box-view-style1">
      <div
        className={`${
          isModal ? "" : "testimonial-content margin_right15 margin_left15"
        }`}
        style={isModal ? { height: "100%" } : { height: "320px" }}
      >
        <div className="d-flex align-items-center">
          <div className="testimonial-avatar">
            <div className="testimonial-img">
              <img className="img-fluid" src={review.img} alt={review.imgAlt} />
            </div>
          </div>
          <div className="testimonial-caption">
            <h3>{review.name}</h3>
            <label>{review.address}</label>
          </div>
        </div>
        <div className="ttm-border-line"></div>
        <div className="star-ratings">
          <ul className="rating">
            {Array(5)
              .fill(1)
              .map((_, index) => (
                <li
                  key={index}
                  className={`${index < review.rating ? "active" : ""}`}
                >
                  <i className="fa fa-star"></i>
                </li>
              ))}
          </ul>
        </div>
        {isModal ? (
          <blockquote>{review.description}</blockquote>
        ) : (
          <blockquote>
            {review.description.length > 120
              ? review.description.substring(0, 120) + "..."
              : review.description}
            {!isModal && review.description.length > 120 && (
              <span
                onClick={() => openModal(review)}
                className="ttm-btn btn-inline ttm-btn-size-md ttm-btn-color-skincolor"
                style={{ cursor: "pointer" }}
              >
                Read More
              </span>
            )}
          </blockquote>
        )}
      </div>
    </div>
  );
}

export default TestimonialItem;
